import {Controller} from "react-hook-form";
import LabelWithHR from "../labels/labelWithHR";
import preventMouseWheelValueChange from "./util";
import Style from "./inputFieldWithLabel.module.css";

/**
 * @deprecated use InputFieldWithLabel instead
 * @returns {JSX.Element}
 * @constructor
 */
const InputController = ({
                             containerStyles,
                             label,
                             name,
                             control,
                             type,
                             controllerClassName,
                             defaultValue,
                             disabled,
                             required,
                             min,
                             rules,
                         }) => {

    return (
        <div className={containerStyles}>
            <LabelWithHR label={label} required={required}/>
            <Controller
                name={name}
                control={control}
                defaultValue={defaultValue}
                rules={rules}
                render={({ field: { onChange, onBlur, value, ref }, fieldState: { error }}) => {
                    return (
                        <>
                        <input
                            type={type ? type : "text"}
                            className={controllerClassName}
                            name={name}
                            onChange={onChange}
                            onBlur={onBlur}
                            ref={ref}
                            disabled={disabled}
                            required={required}
                            value={value}
                            min={min}
                            onWheelCapture={preventMouseWheelValueChange}
                        />
                        {error && <span className={Style.errorMessage}>{error.message}</span>}
                        </>
                    );
                }}
            />
        </div>
    );
};

export default InputController;
